<template>
  <div>
    <el-col
      class="add-item"
      :class="[
        window.width > '900' ? 'horizontal-view-add-item' : 'square-view-item'
      ]"
      v-if="dev === 'phase2'"
    >
      <el-card class="flex-center align-center">
        <el-button
          icon="el-icon-plus dark-lg-icons"
          @click="openTrackDialog('Track Upload')"
          circle
        ></el-button>
        <h3 class="name color-white">Add Track</h3>
      </el-card>
    </el-col>

    <el-col class="col-label horizontal-view" v-if="dev === 'show'">
      <el-card class="flex-center align-center">
        <div
          class="item"
          :class="[window.width > '1000' ? 'flex-start' : 'flex-center']"
        >
          <h3 class="name color-white" v-if="window.width > '1000'">Tracks</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="27"
            viewBox="0 0 18.263 13.457"
            v-else
          >
            <path
              id="music_path"
              data-name="Icon material-queue-music"
              d="M16.035,9H4.5v1.922H16.035Zm0,3.845H4.5v1.922H16.035ZM4.5,18.612h7.69V16.69H4.5ZM17.957,
            9v7.863a2.879,2.879,0,1,0,1.922,2.711V10.922h2.884V9Z"
              transform="translate(-4.5 -9)"
              fill="#fff"
            />
          </svg>
        </div>
        <div class="desc waiting flex-start">
          <h3 class="name color-white">Waiting for admin approval</h3>
        </div>
      </el-card>
    </el-col>
    <el-col
      v-if="dev === 'show'"
      :class="[
        window.width > '900' ? 'horizontal-view-item' : 'square-view-item'
      ]"
      v-for="track in approval.data"
      :key="track.id"
    >
      <el-card shadow="hover">
        <div class="card-image">
          <el-image v-if="track.image_url" :src="track.image_url">
            <div slot="error" class="image-slot"></div>
          </el-image>
          <img v-else src="@/assets/images/no_image.png" />
        </div>
        <h3 class="name flex-center">{{ track.title }}</h3>
        <div class="actions">
          <el-button
            class="delete"
            icon="el-icon-close white-lg-icons"
            @click="deleteT(track.id, 1)"
            circle
          ></el-button>
        </div>
      </el-card>
    </el-col>

    <el-col class="col-label horizontal-view">
      <Filters />
      <DialogTrackPublished/>
    </el-col>

    <el-col class="col-label horizontal-view">
      <el-card class="flex-center align-center" shadow="hover">
        <div
          class="item"
          :class="[window.width > '1000' ? 'flex-start' : 'flex-center']"
        >
          <h3 class="name color-white" v-if="window.width > '1000'">Tracks</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="27"
            viewBox="0 0 18.263 13.457"
            v-else
          >
            <path
              id="music_path"
              data-name="Icon material-queue-music"
              d="M16.035,9H4.5v1.922H16.035Zm0,3.845H4.5v1.922H16.035ZM4.5,18.612h7.69V16.69H4.5ZM17.957,
            9v7.863a2.879,2.879,0,1,0,1.922,2.711V10.922h2.884V9Z"
              transform="translate(-4.5 -9)"
              fill="#fff"
            />
          </svg>
        </div>
        <div class="desc approved flex-start">
          <h3 class="name">Approved</h3>
        </div>
      </el-card>
    </el-col>

    <div class="tracks-wrap">
      <div
        v-show="tracks && tracks.data && tracks.data.length == 0"
        class="no-data"
      >
        <span>No result</span>
      </div>
      <el-col
        :class="[
          window.width > '900' ? 'horizontal-view-item' : 'square-view-item'
        ]"
        v-for="track in tracks.data"
        :key="track.id"
      >
        <el-card shadow="hover">
          <div class="card-image">
            <el-image v-if="track.image_url" :src="track.image_url">
              <div slot="error" class="image-slot"></div>
            </el-image>
            <img v-else src="@/assets/images/no_image.png" />
          </div>
          <h3 class="name flex-center">{{ track.title }}</h3>
          <div class="actions">
            <el-tooltip content="View" placement="top" >
            <el-button
              class="view"
              icon="fas fa-eye white-lg-icons"
              @click="openTrackDialog('Track View', track, 'approved')"
              circle
            ></el-button>
            </el-tooltip>
            <el-tooltip content="Edit" placement="top" >
              <el-button
                  type="warning"
                  circle
                  size="small"
                  icon="el-icon-edit"
                  @click="openEdit(track)"
              ></el-button>
            </el-tooltip>
            <el-button
              v-if="dev === 'phase2'"
              class="edit"
              icon="fas fa-pen white-lg-icons"
              @click="openTrackDialog('Track Edit', track, 'approved')"
              circle
            ></el-button>
          </div>
        </el-card>
      </el-col>

      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogTrack"
        width="700px"
        @close="trackUploadClose"
      >
        <el-form :model="form" :disabled="formDisable">
          <el-form-item
            label="Artist"
            prop="artist_id"
            :label-width="formLabelWidth"
            :disabled="approvedTrackEdit"
          >
            <el-select
              v-model="form.artist_id"
              clearable
              filterable
              @clear="clearArtist()"
              :disabled="approvedTrackEdit"
            >
              <el-option
                v-for="a in artists"
                :key="a.id"
                :value="a.id"
                :label="a.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Upload mp3" :label-width="formLabelWidth">
            <el-upload
              class="el-upload-auto"
              :class="{
                'el-upload-sucess':
                  form.file !== '' && dialogTitle == 'Track Upload'
              }"
              :action="`${url}mytracks/upload/track/${form.artist_id}`"
              :headers="headers"
              accept=".mp3"
              :on-success="onSuccessTrack"
              :on-error="onErrorTrack"
              :on-remove="onRemoveTrack"
              :on-exceed="onExceedTrack"
              :on-progress="onProgressTrack"
              :limit="1"
              name="uploaded"
              ref="uploadTrack"
              :disabled="form.artist_id == null || approvedTrackEdit"
            >
              <i class="el-input__icon el-icon-upload aligh-icon"></i>
              <span v-if="form.file !== ''">{{ form.file }}</span>
              <span v-if="form.file == '' && form.artist_id == null"
                >Select artist first</span
              >
              <span v-if="form.file == '' && form.artist_id !== null"
                >Choose file</span
              >
            </el-upload>
            <i v-if="track_process" class="el-icon-loading loading-track"></i>
            <i
              v-if="
                form.file !== '' &&
                  dialogTitle == 'Track Edit' &&
                  !approvedTrackEdit
              "
              class="el-icon-close removeIcon"
              @click="onRemoveTrack"
            ></i>
          </el-form-item>
          <el-form-item label="Track Name" :label-width="formLabelWidth">
            <el-input
              v-model="form.name"
              placeholder="Add Track Name"
              autocomplete="off"
              :disabled="approvedTrackEdit"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Upload track artwork/cover"
            :label-width="formLabelWidth"
          >
            <el-upload
              class="el-upload-auto"
              :class="{
                'el-upload-sucess':
                  form.cover !== '' && dialogTitle == 'Track Upload'
              }"
              :action="`${url}mytracks/upload/image/${form.id}`"
              :headers="headers"
              accept="image/*"
              :on-success="onSuccessTrackImage"
              :on-error="onErrorTrackImage"
              :on-remove="onRemoveTrackImage"
              :on-exceed="onExceedTrackImage"
              :on-progress="onProgressTrackImage"
              :limit="1"
              name="image"
              ref="uploadTrackImage"
              :disabled="
                form.artist_id == null || form.id == null || approvedTrackEdit
              "
            >
              <i class="el-input__icon el-icon-upload aligh-icon"></i>
              <span v-if="form.cover !== ''">{{ form.cover }}</span>
              <span v-if="form.cover == '' && form.artist_id == null"
                >Select artist first</span
              >
              <span
                v-if="
                  form.cover == '' && form.artist_id !== null && form.id == null
                "
                >Upload track first</span
              >
              <span
                v-if="
                  form.cover == '' &&
                    form.artist_id !== null &&
                    form.id !== null
                "
                >Choose file</span
              >
            </el-upload>
            <i v-if="image_process" class="el-icon-loading loading-track"></i>
            <i
              v-if="form.cover !== '' && dialogTitle == 'Track Edit'"
              class="el-icon-close removeIcon"
              @click="onRemoveTrackImage"
            ></i>
          </el-form-item>
          <el-form-item label="Release date" :label-width="formLabelWidth">
            <el-date-picker
              type="date"
              v-model="form.release_date"
              autocomplete="off"
              prefix-icon="el-icon-date"
              format="d MMMM yyyy"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Spotify link" :label-width="formLabelWidth">
            <el-input
              v-model="form.spotify"
              placeholder="Add Link"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <h3 class="form-subheading">Content ID Manager</h3>
          <div class="flex-space-between">
            <el-tooltip placement="top" effect="light" trigger="hover">
              <div slot="content">
                <img
                  class="info-tooltip"
                  src="@/assets/icons/info.svg"
                  alt=""
                />
                Default<br />
                Content ID will be<br />
                managed by SyncVault
              </div>
              <el-form-item
                label="My CID Manager"
                :label-width="formLabelWidth"
              >
                <el-input
                  class="form-md"
                  v-model="form.cid_manager"
                  placeholder="Add Name"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </div>
          <el-form-item label="My Distributor" :label-width="formLabelWidth">
            <el-input
              class="form-md"
              v-model="form.distributor"
              placeholder="Add Name"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <div class="flex-space-between">
            <el-form-item label="ISRC" :label-width="formLabelWidth">
              <el-input
                class="form-md"
                v-model="form.isrc"
                placeholder="Add Code"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="0">
              <el-button
                type="primary btn-main"
                @click="saveTrack"
                v-show="!formDisable"
                >Save</el-button
              >
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Filters from './Filters'
import DialogTrackPublished from './DialogTrackPublished'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'


export default {
  components: {
    Filters,
    DialogTrackPublished
  },

  data() {
    return {
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      dialogVisibleTrack: false,
      dialogTrack: false,
      subTabsPosition: 'top',
      formLabelWidth: '155px',
      current_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      current_track: null,
      form: {},
      formDisable: false,
      dialogTitle: '',
      dialogType: 'waiting',
      url: process.env.VUE_APP_LABEL_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      track_process: false,
      image_process: false
    }
  },

  computed: {
    ...mapState('labelTracks', [
      'loading',
      'videos_loading',
      'tracks',
      'videos',
      'artists',
      'approval'
    ]),

    approvedTrackEdit() {
      if (this.dialogTitle == 'Track Edit' && this.dialogType == 'approved') {
        return true
      }
      return false
    }
  },

  methods: {
    ...mapMutations('labelTracks', [
      'setLoading',
      'setTrack',
      'setDialogTrack'
    ]),
    ...mapMutations('artistDashboard', [
      'setSelectedArtist',
      'setSelectedTrack'
    ]),
    ...mapActions('labelTracks', [
      'readMyTracks',
      'readArtists',
      'readForApproval',
      'deleteTrack',
      'deleteImage',
      'confirmTrack',
      'updateApprovedTrack'
    ]),
    

    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`)
    },

    openTrackDialog(dialog_title, track = null, type = 'waiting') {
      if (dialog_title == 'Track Edit') {
        this.dialogTrack = true
        this.dialogTitle = dialog_title
        this.dialogType = type
        this.form = {
          id: track.id,
          name: track.title,
          file: track.original_file_name,
          cover: track.image_url
            ? track.image_url.substring(track.image_url.lastIndexOf('/') + 1)
            : '',
          release_date: track.release_date,
          cid_manager: track.cid_manager,
          distributor: track.distributor,
          isrc: track.isrc,
          spotify: track.spotify_link,
          artist_id: track.artist_id ? track.artist_id : track.artist[0].id
        }
      } else if (dialog_title == 'Track View') {
        /*let artist = {
          id: track.artist[0].id,
          name: track.artist[0].name,
          file_name: track.artist[0].images ? track.artist[0].images[0] : null
        }
        let data = {
          id: track.id,
          title: track.title,
          image_url: track.image_url,
          artist_id: track.artist[0].id,
          artist_name: track.artist[0].name,
          file_name: track.artist[0].images ? track.artist[0].images[0] : null,
          type: 'track'
        }
        this.setSelectedArtist(artist)
        this.setSelectedTrack(data)*/
        this.$router.push('/artist/my-tracks/track-details?track=' + track.id)
      }
    },

    openT(track) {
      this.setDialogTrack(true)
      this.setTrack(track)
    },

    saveTrack() {
      if (this.approvedTrackEdit) {
        this.dialogTrack = false
        this.updateApprovedTrack(this.form)
        this.resetTrackForm()
      } else {
        if (this.form.file == '') {
          this.$message({
            type: 'warning',
            message: `You nedd to upload track first`
          })
        } else {
          this.dialogTrack = false
          this.confirmTrack(this.form)
          this.resetTrackForm()
        }
      }
    },
    resetTrackForm() {
      this.form = {
        id: null,
        name: '',
        file: '',
        cover: '',
        release_date: '',
        cid_manager: 'SYNCVAULT',
        distributor: '',
        isrc: '',
        spotify: '',
        artist_id: null
      }
    },
    onSuccessTrack(response) {
      //this.showUpload = !this.showUpload
      this.$message({
        type: 'success',
        message: `File uploaded`
      })
      this.form.id = response.data.id
      this.form.file = response.data.basename
      if (this.form.name == '') {
        this.form.name = response.data.filename
      }
      this.track_process = false
    },

    onErrorTrack(err) {
      this.track_process = false
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemoveTrack() {
      this.deleteT(this.form.id, 0)
      this.form.cover = ''
      this.form.id = null
      this.form.file = ''
      this.form.name = ''
      this.$refs.uploadTrack.clearFiles()
      this.$refs.uploadTrackImage.clearFiles()
    },

    onExceedTrack() {
      this.$message({
        type: 'error',
        message: `Only one track can be uploaded`
      })
    },

    onProgressTrack() {
      this.track_process = true
    },

    onSuccessTrackImage(response) {
      this.$message({
        type: 'success',
        message: `File uploaded`
      })
      this.image_process = false
      this.form.cover = response.data.filename
    },

    onErrorTrackImage(err) {
      this.image_process = false
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemoveTrackImage() {
      this.deleteI(this.form.id)
      this.form.cover = ''
      this.$refs.uploadTrackImage.clearFiles()
    },

    onExceedTrackImage() {
      this.$message({
        type: 'error',
        message: `Only one image can be uploaded`
      })
    },

    onProgressTrackImage() {
      this.image_process = true
    },

    trackUploadClose() {
      if (this.form.id !== null && this.dialogTitle == 'Track Upload') {
        this.deleteT(this.form.id, 0)
        this.resetTrackForm()
        this.$refs.uploadTrack.clearFiles()
        this.$refs.uploadTrackCover.clearFiles()
      } else if (this.dialogTitle == 'Track Edit') {
        this.resetTrackForm()
        this.$refs.uploadTrack.clearFiles()
        this.$refs.uploadTrackCover.clearFiles()
      }
    },

    clearArtist() {
      this.form.artist_id = null
    },

    deleteT(id, message) {
      if (message != 0) {
        this.$confirm(
          'You will permanently delete this track. Continue?',
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        )
          .then(() => {
            this.deleteTrack(id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Delete cancelled'
            })
          })
      } else {
        this.deleteTrack(id)
      }
    },

    deleteI() {
      this.deleteImage(this.form.id)
    },

    openEdit(track) {
      this.setDialogTrack(true)
      this.setTrack(track)
    },
  },

  watch: {
    watchwidth() {
      this.$refs.addTrack.clientWidth()
    },
    dialogTitle(n, o) {
      if (n == 'Track View') {
        this.formDisable = true
      } else {
        this.formDisable = false
      }
    }
  },

  created() {
    this.readMyTracks()
    window.addEventListener('resize', this.windowWidth)
    this.windowWidth()
    this.resetTrackForm()
    this.readArtists()
    let obj = {
      approval: 1
    }
    this.readForApproval(obj)
  },
  destroyed() {
    window.removeEventListener('resize', this.windowWidth)
  }
}
</script>

<style lang="scss" scoped>
.horizontal-view-item .el-card .date-wrap {
  display: flex;
  width: 30%;
  .date {
    width: 100%;
  }
  p {
    margin: 5px 0 10px;
  }
}

.horizontal-view-item .el-card .name {
  width: 30%;
}

.horizontal-view-item .el-card .actions {
  padding-right: 25px;
  display: inline-block;
}

.square-view-item .el-card .actions {
  button {
    margin: 4px 0 !important;
    .fas {
      color: white !important;
    }
  }
}

.loading-track {
  float: right;
  margin-top: 15px;
  margin-right: 5px;
}

.removeIcon {
  float: right !important;
  margin-top: 15px !important;
  cursor: pointer;
}
</style>
